export default "__VITE_ASSET__Cq7ayl_B__"